<template>
  <div class="set-rules">
    <div v-if="!showConfig" class="empty color-Gray_9e">选择一个规则进行设置</div>
    <template v-else>
      <div class="title">设置规则</div>
      <div v-for="field in this._.keys(fields)" :key="field" class="content-item">
        <el-form v-if="field === 'name'" :inline="true" :model="rule" class="name-row">
          <el-form-item
            label="规则名："
            prop="name"
            :rules="[{ required: true, message: '规则名称不能为空', trigger: 'blur' }]"
          >
            <el-input v-model="rule.name" :placeholder="fields[field].tip"></el-input>
          </el-form-item>
        </el-form>
        <template v-else>
          <div
            class="item-title"
            :style="field === 'filters' ? ' border-top: 1px solid #ddd;' : ''"
          >
            {{ fields[field].title }}
          </div>
          <div v-if="field === 'cidList'">
            <div class="empty-text" v-show="fields[field].tip">{{ fields[field].tip }}</div>
            <div class="operate-fields">
              <el-select
                v-model="rule.cidList"
                multiple
                filterable
                clearable
                placeholder="请选择"
                style="width: 100%"
                @change="changeSelect"
              >
                <div style="padding: 5px 20px 8px 20px;border-bottom: 1px solid #eaeaea;">
                  <el-checkbox
                    :value="rule.cidList && rule.cidList.length === canConfigFields.length"
                    @input="selectAll"
                  >
                    全选
                  </el-checkbox>
                </div>
                <el-option
                  v-for="item in canConfigFields"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="field === 'filters'">
            <template v-if="['disabled', 'hide', 'required', 'mutiUnique'].includes(menu)">
              <div v-show="rule.cidList && rule.cidList.length === 0" class="empty-text">
                {{ fields[field].tip }}
              </div>
              <div v-show="rule.cidList && rule.cidList.length !== 0">
                <el-radio-group
                  v-model="rule.whenCreate"
                  class="when-create"
                  @change="changeWhenCreate"
                >
                  <el-radio :label="false">
                    {{ rulesMap[menu].conditionTip }}
                  </el-radio>
                  <el-radio :label="true">
                    {{ rulesMap[menu].newTip }}
                  </el-radio>
                </el-radio-group>
                <condition-list
                  v-if="rule.whenCreate !== true"
                  :conditions="rule.filters"
                  class="condition-list"
                  :search-sheet="sheetInfo"
                  from="sheet_backend"
                  :key="menu"
                ></condition-list>
              </div>
            </template>
            <template v-else-if="menu === 'reasonable'">
              <div class="empty-text">{{ fields[field].tip }}</div>
              <condition-list
                :key="menu"
                class="condition-list"
                from="sheet_backend"
                :conditions="rule.filters"
                :search-sheet="sheetInfo"
                :rely-sheet="sheetInfo"
              ></condition-list>
            </template>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import { rulesMap, ruleFields } from "./static"

export default {
  name: "set-rules",
  components: {
    ConditionList
  },
  props: {
    showConfig: Boolean,
    menu: String,
    canConfigFields: Array,
    sheetInfo: Object
  },
  data() {
    return {
      rulesMap,
      ruleFields,
      cidList: [],
      conditions: [],
      rule: {},
      value: "哈哈"
    }
  },
  computed: {
    fields() {
      return this.ruleFields[this.menu]
    }
  },
  methods: {
    initial(rule) {
      this.rule = rule
    },
    changeWhenCreate() {
      if (this.rule.whenCreate) {
        this.rule.filters = []
      }
    },
    selectAll(selected) {
      this.rule.cidList = selected ? this.canConfigFields.map(item => item.value) : []
    },
    changeSelect(val) {
      this.rule.cidList = val
    }
  }
}
</script>

<style lang="scss" scoped>
.set-rules {
  box-sizing: border-box;
  border-left: 1px solid #ddd;
  padding: 20px 0;
  color: #333;
  .empty {
    margin-top: 150px;
    font-size: 14px;
    text-align: center;
  }
  .title {
    font-size: 16px;
    padding: 0 20px;
  }
  .content-item {
    .empty-text {
      color: #888888;
      padding: 0 12px;
      margin: 12px 20px;
      background-color: #f5f5f5;
      height: 36px;
      border-radius: 3px;
      font-size: 13px;
      line-height: 36px;
    }
    .item-title {
      padding: 20px 20px 14px;
      font-size: 14px;
      font-weight: bold;
      & + .empty-text {
        margin: 0 20px;
      }
    }
    .operate-fields {
      box-sizing: border-box;
      margin-top: 0;
      margin-bottom: 14px;
      padding: 0 20px;
    }
    .name-row {
      display: flex;
      padding: 10px 20px 0;
      ::v-deep .el-form-item {
        display: flex;
        width: 100%;
        .el-form-item__content {
          flex: auto;
        }
      }
      .name-label {
        min-width: 66px;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .when-create {
      padding: 0 20px;
    }
    .condition-list {
      padding: 0 20px 10px 20px;
      ::v-deep .addConditionBtn {
        font-size: 13px;
        margin-top: 6px;
      }
      ::v-deep .flexRow {
        .compareMethod {
          min-width: 90px;
        }
        .compareValue {
          .el-tag {
            display: inline-block;
            height: auto;
            white-space: normal;
          }

          .refDataSelector {
            max-width: 234px;
            left: 0;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.set-rules {
  .content-item {
    .el-input__inner {
      border-width: 1px;
    }
  }
}
</style>
